import { render, staticRenderFns } from "./NewsToggle.vue?vue&type=template&id=ddf5634e&scoped=true"
import script from "./NewsToggle.vue?vue&type=script&lang=js"
export * from "./NewsToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf5634e",
  null
  
)

export default component.exports